import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import { Linelogin, Fblogin, Analytics } from './elements'

// temp for test
// import Cookies from "js-cookie";

class Login extends Component {

    constructor() {
        super()
        this.state = {
            isFbLogin: false,
            user: ""
        }
    }

    // Temp for test
    // componentDidMount() {
    //     Cookies.set('user', {username: "test", rank: "1"})
    //     window.location = "/"
    // }
    // End Temp for test

    FbCallBack(res) {
        // console.log("Fb Callback", res)
        if(res.status !== "unknown") {
            this.setState({ 
                isFbLogin: true,
                user: res
            })
        }
    }

    render() { 
        if(this.state.isFbLogin) return <Redirect to={{ pathname:"/loginverifyfb", search:`?id=${this.state.user.id}&pic=${this.state.user.picture.data.url}`}} />
        return ( 
            <div className="page_login">
                <Analytics />
                <div className="container">
                    <div className="section-logo">
                        <img src={require("../static/images/01_login/logo.png")} alt="apslogo"/>
                    </div>
                    <div className="section-social-login">
                        <Linelogin />
                        <Fblogin callback={(res)=>this.FbCallBack(res)}/>
                    </div>
                </div>
            </div>
        )
    }
}
 
export default Login;